module.exports = __webpack_public_path__ + "img/商城昆明联通流量卡.67d8cfee.png";